var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',{staticClass:"mt-0",attrs:{"disabled":_vm.item.state !== 'PC',"label":_vm.item.finished ? _vm.$t('button.finished') : _vm.$t('button.unfinished'),"inset":"","color":"green"},on:{"change":_vm.finish},model:{value:(_vm.item.finished),callback:function ($$v) {_vm.$set(_vm.item, "finished", $$v)},expression:"item.finished"}})
}
var staticRenderFns = []

export { render, staticRenderFns }